import { L } from '@/plugins/utils/i18n';

import { getColor, getRankColor, seconds2HHmm } from '@/plugins/utils/utils.js';

import {
  chart_dates, // 图表横轴的日期与报告数据之间的映射关系
  getInterval
} from './variables.js';

const monthNameArray = [L.jan, L.feb, L.mar, L.apr, L.may, L.jun, L.jul, L.aug, L.sep, L.oct, L.nov, L.dec];
export function setSOLChartOption (reports, sol_chart) {
  if (!sol_chart) {
    return;
  }

  const dataSOL = [];
  const dataXAxis = [];

  // 从日期序列转换到图表数据
  let weekmode = false;
  if (Object.keys(reports).length > 0) {
    const total = Object.keys(chart_dates).length;
    // 如果周期太长，以周为单位计算均值
    if (total <= 60) {
      for (const key in chart_dates) {
        const [month, day] = key.split('/');
        const abbrKey = month + '-' + day;
        
        // 检查 reports[key] 是否存在
        let sol = null;
        if (reports[key] && typeof reports[key].sol !== 'undefined') {
            sol = Math.round(reports[key].sol);
        }
        // let c = getRankColor(reports[key], 'sol', sol) ;
        dataSOL.push({ name: abbrKey, value: sol, itemStyle: { color: '#73c0de' } });
        dataXAxis.push(abbrKey);
      }
    } else {
      weekmode = true;
      let [sol_avg, count] = [0, 0];
      let valid = false; // 跳过开头的“半周”
      let weekend = '';
      for (let key in chart_dates) {
        const [year, month, day] = key.split('-');
        const d = new Date();
        d.setFullYear(year);
        d.setMonth(month - 1);
        d.setDate(day);
        d.setHours(0, 0, 0, 0);
        const weekday = d.getDay();

        const sol = chart_dates[key] >= 0 ? Math.round(reports[chart_dates[key]].sol) : null;
        if (sol != null && valid) {
          sol_avg += sol;
          count++;
        }
        if (weekday === 6) { // 每周最后一天
          weekend = month + '-' + day;
        }
        if (weekday === 0) { // 每周第一天
          if (valid) {
            sol_avg = count ? Math.round(sol_avg / count) : null;
            key = month + '-' + day + L.to + weekend;
            const c = getRankColor(null, 'sol', sol_avg);
            dataSOL.push({ name: key, value: sol_avg, itemStyle: { color: c } });
            dataXAxis.push(key);
            [sol_avg, count] = [0, 0];
            weekend = '';
          } else {
            valid = true;
          }
        }
      }
    }
  }
  dataSOL.reverse();
  dataXAxis.reverse();

  const option = {
    animationDuration: 500,
    backgroundColor: 'transparent',
    /* title: {
            text: '入睡速度 (分钟)',
            padding: [0, 0, 0, 32],
            textStyle: {
                fontWeight: 'normal',
                fontSize: 14
            }
        }, */
    tooltip: {
      trigger: 'axis',
      confine: true,
      order: 'seriesDesc',
      shadowBlur: 4,
      backgroundColor: getColor('background'),
      textStyle: {
        fontSize: 12,
        lineHeight: 9,
        textShadowBlur: 2,
        textShadowColor: 'transparent',
        color: getColor('text')
      },
      axisPointer: {
        type: 'line',
        label: {
          show: true,
          backgroundColor: '#6a7985'
        }
      },
      valueFormatter: (value) => {
        if (value > 0 || value === 0) {
          return seconds2HHmm(value * 60, true);
        } else {
          return '-';
        }
      }
    },
    grid: {
      top: '5%',
      left: '3%',
      right: '3%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      boundaryGap: true,
      axisTick: { alignWithLabel: true },
      axisLabel: {
        showMinLabel: true,
        showMaxLabel: true,
        fontSize: 10,
        rotate: weekmode ? 0 : 45,
        interval: weekmode ? 0 : getInterval,
        formatter: (value) => {
          if (weekmode) {
            const [weekstart, weekend] = value.split(L.to);
            const [startMonth, startDay] = weekstart.split('-');
            const [endMonth] = weekend.split('-');
            if (startMonth !== endMonth || startDay === 1) { // 月初
              return monthNameArray[parseInt(endMonth) - 1];
            } else { return '' }
          } else { return value; }
        }
      },
      data: dataXAxis
    }],
    yAxis: {
      type: 'value',
      min: 0,
      minInterval: 10,
      axisLabel: {
        show: true,
        formatter: '{value}' + L.time_min
      }
    },
    series: [{
      name: L.sleep_onset_latency,
      type: 'line',
      smooth: true,
      // symbol: weekmode ? 'emptyCircle' : (value, params)=>{ return getSymbol(value, params, dataSOL); },
      symbol: 'circle',
      symbolSize: 5,
      lineStyle: { color: getColor('linegray1') },
      itemStyle: { color: getColor('linegray1') },
      data: dataSOL
    }]
  };
  sol_chart.setOption(option);
}
